import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's no hash, scroll to the top of the page
    if (!hash) {
      window.scrollTo(0, 0);
    }
    // Otherwise, scroll to the element with the hash ID (if it exists)
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop; 